import * as React from "react";
import { Redirect } from "react-router-dom";
import Loader from 'react-loader';
import { toast, ToastContainer} from 'react-toastify';
import {Button, Input} from 'reactstrap';
import SortableTbl from "react-sort-search-table";

import { Wrapper, Content, ContentCol , ContentRow, ContentRowSingleCol, InputWrapper} from './InteractionSet.styles';
import Navbar from '../../../../components/CustomNav/CustomNav.Component';
import withServices  from '../../../../HOCs/withServices';

interface IProps {
    services?: any;
    location?: any;
    match?: any;
    history?: any;
}
  
interface IState {
    toLogin: boolean;
    loaded: boolean;
    data: any;
    selectedLesson: string;
    isNavigate: boolean;
    destination: string;
}

class InteractionSet extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
    
        this.state = {
          destination: '',
          toLogin: false,
          loaded: true,
          isNavigate: false,
          data: {},
          selectedLesson: '',
        };
    
        this.onLogout = this.onLogout.bind(this);
        this.onGoBack = this.onGoBack.bind(this);
        this.updateInfo = this.updateInfo.bind(this);
        this.handleChange =  this.handleChange.bind(this);
        this.onGoToCreate = this.onGoToCreate.bind(this);
        this.goToInteractionList = this.goToInteractionList.bind(this);
    }

    public onGoBack() {
        const { history } = this.props;
        // history.goBack();
        // window.history.back();
        const dest = this.props.services.currentBaseUrl + 'interaction_sets';
        
        console.log(dest)
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public onLogout() {
        this.setState({ toLogin: true });
    }

    public async componentDidMount() {
        const {
            match,
            history,
            location,
            services: { isUserLoggedIn, adminAPI, currentUserID },
        } = this.props;

        if (!isUserLoggedIn) { this.setState({ toLogin: true }); }

        const { params: { id: interactionSetID } } = match;

        const [setInfoRes, InteractionsRes] = await Promise.all([adminAPI.getSingleItemGeneral('interaction_sets', interactionSetID), adminAPI.getInteractions()]);

        const interactionsDataKey = ["id", "name", "interaction_set", "created_by", "created_at","delete"];
        
        const interactionThead = ["ID", "Name", "Set", "Creator", "Date", "Action"];

        // const setInfoRes = await adminAPI.getSingleItemGeneral('interaction_sets', interactionSetID);
    
        if (setInfoRes.ok) {
            
            const interactionSet = setInfoRes.data;

            const interactions = InteractionsRes.data.interactions;

            this.setState(
                {
                     data: {
                        interactionSet,
                        interactionSetID,
                        interactions,
                        interactionsDataKey,
                        interactionThead
                     }
                }
            )
        } else {
            toast.error('Error fetching course details!');
        }
    }

    public handleChange(id, e) {
        console.log(e)
        const data = this.state.data
        data.interactionSet[id] = e.target.value;
        this.setState({
            data
        });
    }

    public async updateInfo() {
        this.setState({
            loaded: false
        });

        const item = this.state.data.interactionSet;

        const res = await this.props.services.adminAPI.updateItemGeneral('interaction_sets', item, item.id);

        if (res.ok) {
            toast.success('Update Successful');
        }
        else {
            toast.error('Update Failed')
        }

        this.setState({
            loaded: true
         });
    }

    public onGoToCreate() {
        const dest = this.props.services.currentBaseUrl + 'interactions_creator';
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public async goToInteractionList() {
    
        const dest = this.props.services.currentBaseUrl + 'interaction_set_list/' + this.state.data.interactionSetID
        
        console.log(dest)
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public render() {
        const {data} = this.state;
    
        if (this.state.toLogin) {
          return <Redirect to="/login" />;
        }

        if (this.state.isNavigate) {
            return <Redirect to={this.state.destination} />;
          }
    
        if (Object.keys(data).length === 0) {
          return <Loader color="#acff24" />;
        }

        return (
            <Wrapper>
              <ToastContainer/>
              <Navbar logoutParent={this.onLogout} />
              <Content>
                <ContentRow className="single-col">
                  <p className="go-back" onClick={this.onGoBack}>&lt; Back</p>
                </ContentRow>
              </Content>


              <Content>
                <ContentRow>

                    <ContentCol>
                        <div>
                            <label htmlFor="title" style={{ display: 'block' }}>
                                Title
                            </label>
                            {/*tslint:disable-next-line jsx-no-lambda*/}
                            <textarea rows={6} cols={38} id="title" value={data.interactionSet.name} onChange= {(e) => this.handleChange('name', e)}/>
                        </div>
                    
                    </ContentCol>

                    <ContentCol>
                        <div>
                            <label htmlFor="description" style={{ display: 'block' }}>
                                Description
                            </label>
                            {/*tslint:disable-next-line jsx-no-lambda*/}
                            <textarea rows={6} cols={38} id="description" value={data.interactionSet.description} onChange= {(e) => this.handleChange('description', e)}/>
                        </div>
                    
                    </ContentCol>

                </ContentRow>
              </Content>
              <Content>
                <ContentRowSingleCol>
                  <div>
                    <Button onClick={this.updateInfo}>
                      Update
                    </Button>

                    <Button style={{marginLeft: '5px'}} onClick={this.goToInteractionList}>Interactions</Button>
                  </div>
                </ContentRowSingleCol>
              </Content>
            </Wrapper>    
        );
    
    }

}

export default withServices(InteractionSet);


// WEBPACK FOOTER //
// ./src/pages/Admin/InteractionSets/InteractionSet/InteractionSet.tsx